import { SHOW_SPINNER_MOVEMENT, HIDE_SPINNER_MOVEMENT } from './constants';

export const showSpinnerMovement = () => ({ type: SHOW_SPINNER_MOVEMENT });
export const hideSpinnerMovement = () => ({ type: HIDE_SPINNER_MOVEMENT });
